import r from '../utils/request'
import { ACTIVE_STATUS, API_ROOT } from '../utils/constants'

// The API sends a short-lived signed path for a recipe's audio memory
const withAudioUrl = (response) => {
  if (response?.data?.audio) {
    response.data.audio = `${API_ROOT}${response.data.audio}`
  }
  return response
}

export const createRecipe = (params) => {
  return r.post('/recipes', params).then(withAudioUrl)
}

export const getRecipe = (status = ACTIVE_STATUS, params) => {
  return r.get('/recipes/my', { status, ...params })
}

// People who share a family group with the user, to add a recipe for ("Whose recipe is this?")
export const getFamilyMembers = () => {
  return r.get('/recipes/family-members')
}

export const getRecipeById = (id, to_edit = true) => {
  return r.get(`/recipes/${id}`, { to_edit }).then(withAudioUrl)
}

// Something done with a recipe on its page, for follow-up emails: 'started_cooking'
// (ticked off ingredients) or 'printed'. Never shown to the person, so failures are ignored.
export const recordRecipeAction = (id, action, { groupId, ingredientCount } = {}) => {
  return r
    .post(`/recipes/${id}/actions`, {
      action,
      ...(groupId ? { group_id: Number(groupId) } : {}),
      ...(ingredientCount ? { ingredient_count: ingredientCount } : {}),
    })
    .catch(() => null)
}

export const getRecipesByCategory = (params) => {
  return r.get(`/groups/${params?.idGroup}/categories/${params?.codeCategory}`, {
    page: params?.page,
    size: params?.size,
  })
}

export const getRecipeByUserIdGroupId = (idUser, idGroup) => {
  return r.get(`/recipes/groups/${idGroup}/users/${idUser}`)
}

export const deleteRecipe = (id) => {
  return r.delete(`/recipes/${id}`)
}

export const reportRecipe = (params) => {
  return r.post('/report', params)
}

export const getVideoRecipe = () => {
  return r.get('/recipes/video')
}

export const getRecipesForOrder = (groupId, order_id) => {
  return r.get(`/recipes/group/${groupId}/all`, { order_id })
}

// Every recipe the user can see, across all of their groups
export const searchRecipes = (q) => {
  return r.get('/recipes/search', { q })
}

// Reads photos of a recipe card and returns recipe fields to prefill the form. Saves nothing.
export const scanRecipeCard = (photos) => {
  const formData = new FormData()
  photos.forEach((photo, index) => formData.append('images[]', photo, `card-${index + 1}.jpg`))
  return r.post('/recipes/scan', formData)
}

// Reads a recipe from a web page link and returns recipe fields to prefill the form. Saves nothing.
export const importRecipeFromLink = (url) => {
  return r.post('/recipes/from-link', { url })
}
